import { JSX } from 'react';

import { Icon } from 'components/icon';
import { AnalyticsEmployeeDetails } from 'store/api/analytics';

export const titles = ['Time', 'Sale code', 'Employee', 'Sale total'];
export const template = 'repeat(4, 1fr)';

interface Result {
  title: string;
  icon: JSX.Element;
  value?: string | number;
  withoutFormat?: boolean;
}

export const getInfoData = ({
  data,
  commissionPercent,
  hideEmployeeCommissions,
}: {
  commissionPercent?: number;
  data?: AnalyticsEmployeeDetails;
  hideEmployeeCommissions?: boolean;
}) => {
  const result: Result[] = [
    {
      title: 'Today Sales',
      icon: <Icon.Change />,
      value: data?.grossContribution,
    },
    {
      title: 'PRP',
      withoutFormat: true,
      icon: <Icon.Banknote />,
      value: `${data?.productRevenuePercentage}%`,
    },
    {
      title: 'Avg Sale',
      icon: <Icon.Billing />,
      value: data?.averageSale,
    },
    {
      title: 'Sales QTY',
      withoutFormat: true,
      icon: <Icon.Boxes />,
      value: data?.checkouts?.length,
    },
  ];

  if (!hideEmployeeCommissions) {
    result.push(
      {
        title: 'Commission',
        withoutFormat: true,
        icon: <Icon.Discount />,
        value: commissionPercent && `${commissionPercent}%`,
      },
      {
        value: data?.commissions,
        icon: <Icon.StarEmpty />,
        title: 'Sales commissions',
      },
      {
        icon: <Icon.Coins />,
        title: 'Month total',
        value: data?.total?.monthlySales,
      },
      {
        icon: <Icon.Bank />,
        title: 'Year Total',
        value: data?.total?.yearlySales,
      }
    );
  }

  return result;
};
